import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import {AppheaderComponent} from './appheader/appheader.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import {LayoutModule} from '../layout/layout.module';
import { ChatModule } from '../chat/chat.module';
import { AccountManagementComponent } from './account-management/account-management.component';
import { SharedModule } from '../shared/shared.module';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { ProfileComponent } from './profile/profile.component';
import { AngularMaterialModule } from '../angular-material.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DragDropModule } from '@angular/cdk/drag-drop';

import {NgxPaginationModule} from 'ngx-pagination';
import { RcComponent } from './rc/rc.component';
import { RedactionComponent } from './redaction/redaction.component';


@NgModule({
  declarations: [DashboardComponent, AccountManagementComponent, ProfileComponent, RcComponent, RedactionComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    LayoutModule,
    SharedModule,
    ChartsModule,
    AngularMaterialModule,
    DragDropModule,
    NgxPaginationModule,
    NgxDaterangepickerMd.forRoot()   
  ],
  providers: [
    ThemeService
  ],
})
export class DashboardModule { }
